/**
 * The tenant app's one TanStack Query client.
 *
 * It lives in its own module rather than being created inline in `main.ts`
 * because something other than the component tree has to reach it: the auth
 * store empties it on every session boundary (sign-out, local sign-out, a new
 * sign-in). Cached server state is per user AND per tenant, but query keys are
 * not — `['attention', 'summary']` is the same key for everybody — so a cache
 * that outlived a sign-out would show the next person on the same tab the
 * previous person's figures for up to the 30-second stale window, and from
 * another tenant if they signed in elsewhere (CLAUDE.md §0.6).
 *
 * Tests keep creating their own clients through `createQueryClient`; this
 * instance is only what `main.ts` installs and what `stores/auth.ts` clears.
 */

import { createQueryClient } from '@erpx/ui'

export const queryClient = createQueryClient()

/**
 * Drop every cached query and mutation, cancelling any still in flight so a
 * response that lands after the boundary cannot repopulate the cache.
 * Synchronous on purpose: callers rely on it having happened before their next
 * statement, which may be a network call that never returns.
 */
export function clearQueryCache(): void {
  queryClient.clear()
}
